import { Button } from '@kenect-ut/kenect-ui-kit'
import PropTypes from 'prop-types'
import { useDropdownClose } from '../../../components/dropdown/Dropdown'

function DropdownActions({ save, disabled }) {
  const close = useDropdownClose()
  const handleSave = (event) => {
    event.preventDefault()
    close()
    save()
  }
  const handleClose = (event) => {
    event.preventDefault()
    close()
  }
  return (
    <div className="navDateRangePickerActionBar">
      <Button className="mr-16" variant="tertiary" onClick={handleClose}>
        Cancel
      </Button>
      <Button onClick={handleSave} disabled={disabled}>
        Apply
      </Button>
    </div>
  )
}

DropdownActions.propTypes = {
  save: PropTypes.func,
  disabled: PropTypes.bool,
}

export default DropdownActions
